module.exports = __webpack_public_path__ + "img/one.8a60f5dd.png";